import { client } from '..';
import { ChatRoomIndividualNpo, ChatRoomVolunteerEvent } from '../models/chatRoomModels';
import { VolunteerEventSignUpResponse } from '../models/volunteerModels';

//Volunteers Events
export const getVolunteerEventsChatRooms = async (): Promise<ChatRoomVolunteerEvent[]> => {
  const url = '/chat-rooms/volunteers/list';

  const { data } = await client.get(url);

  return data;
};

export const signUpVolunteerEvent = async ({
  volunteerId
}: {
  volunteerId: string;
}): Promise<VolunteerEventSignUpResponse> => {
  const url = '/chat-rooms/volunteers/sign-up';

  const { data } = await client.post(url, {
    volunteerId: volunteerId
  });

  return data;
};

export const publishMsgChatRoom = async ({
  volunteerId,
  message
}: {
  volunteerId: string;
  message: string;
}): Promise<any> => {
  const url = '/chat-rooms/volunteers';

  const { data } = await client.post(url, {
    volunteerId: volunteerId,
    message: message
  });

  return data;
};

export const editMsgChatRoom = async ({
  volunteerId,
  message,
  idMessage
}: {
  volunteerId: string;
  message: string;
  idMessage: string;
}): Promise<any> => {
  const url = `/chat-rooms/volunteers/${volunteerId}`;

  const { data } = await client.patch(url, {
    volunteerId: volunteerId,
    message: message,
    idMessage: idMessage
  });

  return data;
};

export const deleteMsgChatRoom = async ({
  idMessage,
  volunteerId
}: {
  idMessage: string;
  volunteerId: string;
}): Promise<any> => {
  const url = `/chat-rooms/volunteers/message`;

  const { data } = await client.delete(url, {
    data: {
      volunteerId: volunteerId,
      idMessage: idMessage
    }
  });

  return data;
};

//Individual to NPO
export const getUserNpoChatRooms = async (): Promise<ChatRoomIndividualNpo[]> => {
  const url = '/chat-rooms/user-npo/list';

  const { data } = await client.get(url);

  return data;
};

export const publishResponseUserNpoChatRoom = async ({
  volunteerId,
  message,
  nonProfitOrgId
}: {
  volunteerId: string;
  message: string;
  nonProfitOrgId: string;
}): Promise<any> => {
  const url = '/chat-rooms/user-npo';

  const { data } = await client.post(url, {
    volunteerId: volunteerId,
    nonProfitOrgId: nonProfitOrgId,
    message: message
  });

  return data;
};

export const publishMsgUserNpoChatRoom = async ({
  message,
  nonProfitOrgId,
  chatKey
}: {
  message: string;
  nonProfitOrgId: string;
  chatKey: string;
}): Promise<any> => {
  const url = '/chat-rooms/user-npo/message';

  const { data } = await client.post(url, {
    nonProfitOrgId: nonProfitOrgId,
    message: message,
    chatKey: chatKey
  });

  return data;
};

export const editMsgNpoUserChatRoom = async ({
  nonProfitOrgId,
  message,
  msgId,
  chatKey
}: {
  nonProfitOrgId: string;
  message: string;
  msgId: string;
  chatKey: string;
}): Promise<any> => {
  const url = `/chat-rooms/user-npo`;

  const { data } = await client.patch(url, {
    nonProfitOrgId: nonProfitOrgId,
    message: message,
    msgId: msgId,
    chatKey: chatKey
  });

  return data;
};

export const deleteMsgNpoUserChatRoom = async ({
  msgId,
  nonProfitOrgId,
  chatKey
}: {
  msgId: string;
  nonProfitOrgId: string;
  chatKey: string;
}): Promise<any> => {
  const url = `/chat-rooms/user-npo`;

  const { data } = await client.delete(url, {
    data: {
      nonProfitOrgId: nonProfitOrgId,
      msgId: msgId,
      chatKey: chatKey
    }
  });

  return data;
};

//Npo Donations
export const getNpoDonationsChatRooms = async (): Promise<ChatRoomIndividualNpo[]> => {
  const url = '/chat-rooms/npo-donations/list';

  const { data } = await client.get(url);

  return data;
};

export const signUpNpoDonation = async ({ nonProfitOrgId }: { nonProfitOrgId: string }): Promise<any> => {
  const url = '/chat-rooms/npo-donations/subscribe';

  const { data } = await client.post(url, {
    nonProfitOrgId: nonProfitOrgId
  });

  return data;
};

export const publishMsgNpoDonationChatRoom = async ({
  nonProfitOrgId,
  message
}: {
  nonProfitOrgId: string;
  message: string;
}): Promise<any> => {
  const url = '/chat-rooms/npo-donations/message';

  const { data } = await client.post(url, {
    nonProfitOrgId: nonProfitOrgId,
    message: message
  });

  return data;
};

export const editMsgNpoDonationChatRoom = async ({
  nonProfitOrgId,
  message,
  msgId
}: {
  nonProfitOrgId: string;
  message: string;
  msgId: string;
}): Promise<any> => {
  const url = `/chat-rooms/npo-donations/message`;

  const { data } = await client.patch(url, {
    nonProfitOrgId: nonProfitOrgId,
    message: message,
    msgId: msgId
  });

  return data;
};

export const deleteMsgNpoDonationChatRoom = async ({
  msgId,
  nonProfitOrgId
}: {
  msgId: string;
  nonProfitOrgId: string;
}): Promise<any> => {
  const url = `/chat-rooms/npo-donations/message`;

  const { data } = await client.delete(url, {
    data: {
      nonProfitOrgId: nonProfitOrgId,
      msgId: msgId
    }
  });

  return data;
};
